import { Component, OnInit, Input, ViewChild, Renderer2, OnDestroy, DoCheck } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { RteToolbarViewModel, RteIconComponent, IRteListButtonItem, AfterGet, BeforeSave, RteDialog, RTEAlertService } from 'rte-library';
import { Report } from '../models/report.model';
import { MatTabGroup, MatTabChangeEvent } from '@angular/material';
import { ReportEntity } from '../models/report-entity.model';
import { ReportService } from '../report.service';
import { QueryService } from 'src/app/reports/services/query.service';
import { EntityService } from '../../entity/entity.service';
import { ICallback } from 'src/app/reports/models/Icallback.model';
import { DialogConfirmHelper } from 'src/app/reports/helpers/dialogconfirm.helper';
import { Entity } from '../../entity/entity.model';
import { SchemaForm } from 'src/app/reports/shared/rte-form/schema/schema.model';
import { BaseComponent } from 'src/app/reports/shared/utils/base.component';
import { getRandomId } from 'src/app/reports/helpers/data.helper';
import { validateForm } from '../report.validation';
import { FilterTypeEnum } from 'src/app/reports/enums/filter-type.enum';
import { QueryComponent } from './query/query.component';
import { EntityTypeEnum } from 'src/app/reports/enums/entity-type.enum';
import { TotalizerTypeEnum } from 'src/app/reports/enums/column-type.enum';
import { FilterOptionsComponent } from './filter-options/filter-options.component';

@Component({
  animations: [
    trigger('form-visibility', [
      state('fullscreen', style({
        opacity: 0,
        height: '0px',
        'margin-bottom': '10px'
      })),
      state('default', style({
        opacity: 1
      })),
      transition('* <=> *',  animate('250ms 0s ease-in-out'))
    ])
  ],
  selector: 'app-report-form',
  templateUrl: './report-form.component.html',
  styleUrls: ['./report-form.component.scss']
})
export class ReportFormComponent extends BaseComponent implements OnInit, OnDestroy, DoCheck {

  @Input() toolbarObject: RteToolbarViewModel<any>;
  @Input() schemaForm: SchemaForm;

  //#region ViewChilds

  @ViewChild('circleIcon', {read: RteIconComponent}) circleRef: RteIconComponent;
  @ViewChild('matGroupRef', {read: MatTabGroup}) matGroupRef: MatTabGroup;
  @ViewChild('filterOptions') filterOptions: FilterOptionsComponent;
  @ViewChild('query') query: QueryComponent;
  //#endregion

  //#region Properties
  entities: Array<ReportEntity> = new Array<ReportEntity>();

  reloadComponent: boolean;

  firstLoad = true;
  pristineProviderId: number;
  backingToPristineValue = false;
  countChanges = 0;

  listButtons: Array<IRteListButtonItem> = new Array<IRteListButtonItem>();
  previewButton: IRteListButtonItem;

  queryAnimation = 'stoped';
  fullScreenState = 'default';
  sessionId = '';
  disabled = false;
  verifyChanges = true;
  lastBrowserMode: boolean;
  lastEditMode: boolean;
  canShowFilterOptions: boolean;
  canShowColumnOptions: boolean;
  nameReport = '';
  reportViewer: boolean;

  //#endregion

  //#region Ctor
  constructor(public service: ReportService,
  private queryService: QueryService,
  private entityService: EntityService,
  public dialog: RteDialog,
  private renderer: Renderer2,
  private alert: RTEAlertService) {
    super();
  }

  //#endregion

  //#region Interface Implementations

  ngOnInit() {
    setTimeout(() => {
      this.canShowFilterOptions = true;
      this.canShowColumnOptions = true;
    }, 2000);

    this.reloadComponent = true;

    this.setSessionId();

    this.setToolbarEventListeners();

    this.setSchemaProvider();
    this.titleReport();
    this.loadEntitiesByProvider(null);
  }

   ngOnDestroy() {
    this.queryService.clearEntityColumnHeader();
    this.subscription.unsubscribe();
   }

   ngDoCheck() {
    this.disabled = this.toolbarObject.readonlyBrowserMode;

    this.verifyBoardVisibility();

    this.titleReport();
  }

  //#endregion

  //#region Initial Methods

  viewReport() {
    this.reportViewer = true;
  }

  feedback(response: boolean) {
    this.reportViewer = response;
  }

  titleReport() {
    const current = this.toolbarObject.current;

    if (current.Name !== undefined && current.Name !== null) {
      this.nameReport = 'Relatório - ' + current.Name;
    } else {
      this.nameReport = 'Relatório';
    }
  }

  setSchemaProvider() {
    if (this.schemaForm && this.schemaForm.Rows && this.schemaForm.Rows.length > 0) {
      const find = this.schemaForm.Rows[0].Columns.find(x => x.PropertyName === 'Provider.Id');

      if (find) {
        this.subscription.add(find.OnValueChange.subscribe(x => this.onProviderChange()));
      }
    }
  }


  verifyBoardVisibility() {
    const currentBrowserMode = this.toolbarObject.readonlyBrowserMode,
    currentEditMode = this.toolbarObject.readonlyEditMode,
    current = this.toolbarObject.current,
    showBoard = current && current.Provider && current.Provider.Id && this.entities.length > 0 && !this.toolbarObject.readonlyFirstMode;

    if (this.lastBrowserMode !== currentBrowserMode && this.lastEditMode === true) {
      this.clearChanges();
      this.setDefaultFullScreenState();

      if (current.Provider)
        this.loadEntitiesByProvider(current.Provider.Id);
      this.firstLoad = false;
    }

    this.lastBrowserMode = currentBrowserMode;
    this.lastEditMode = currentEditMode;
  }


  //#endregion

  //#region rte-Toolbar Events

  setToolbarEventListeners() {
    const toolbarComponent = this.toolbarObject.toolbarComponent;
    this.subscription.add(toolbarComponent.customizeAfterClear.subscribe(x => this.customizeAfterClear()));
    this.subscription.add(toolbarComponent.customizeAfterGet.subscribe(x => this.customizeAfterGet(x)));
    this.subscription.add(toolbarComponent.validateBeforeSave.subscribe(x => this.validateBeforeSave(x)));
  }

  customizeAfterClear() {
    this.firstLoad = true;
    this.toolbarObject.current = new Report();
    this.toolbarObject.searchObject = new Report();

    this.setDefaultFullScreenState();

    this.clearChanges();
  }

  customizeAfterGet(afterGet: AfterGet) {
    this.firstLoad = true;

    this.setDefaultFullScreenState();

    if (afterGet.success && this.toolbarObject.current) {
      this.onProviderChange();
    }
  }

  validateBeforeSave(beforeSave: BeforeSave) {
    const validation = validateForm(this.toolbarObject.current);

    if (validation) {
      beforeSave.cancelSave = true;
      this.alert.warning(validation);
    }

    if (!beforeSave.cancelSave && this.countChanges > 0 && this.toolbarObject.toolbarComponent != null) {
      beforeSave.cancelSave = true;
      this.updateQuery({
        callback: () => {
          this.toolbarObject.toolbarComponent.save();
        }
      });
    }
  }

  //#endregion

  //#region Query

  updateQueryClick(event) {
    if (this.countChanges) {
      this.updateQuery(null);
      this.verifyChanges = false;
      this.clearChanges();
    }
  }

  updateQuery(callback: ICallback) {
    this.setQuery(callback);
    this.setQueryDetail(callback);
  }

  initializeRotatingAnimation() {
    this.renderer.addClass(this.circleRef._elementRef.nativeElement, 'rotating');
  }

  stopRotatingAnimation() {
    this.renderer.removeClass(this.circleRef._elementRef.nativeElement, 'rotating');
  }

  setQuery(callback: ICallback) {
    this.initializeRotatingAnimation();

    this.subscription.add(
      this.queryService.getQuery(this.toolbarObject.current)
      .subscribe(value => {
        this.toolbarObject.current.Query = value.Query;

        if (!this.isEntityWithGrouping()) {
          this.afterLoadQuery(callback);
        }
      })
    );
  }

  setQueryDetail(callback: ICallback) {
    if (this.isEntityWithGrouping()) {
      this.subscription.add(
        this.queryService.getQueryDetail(this.toolbarObject.current).subscribe(value => {
          this.toolbarObject.current.QueryDetail = value.Query;
          this.query.query.originalQuery = this.toolbarObject.current.Query;
          this.afterLoadQuery(callback);
        })
      );
    } else {
      this.toolbarObject.current.QueryDetail = '';
    }
  }

  afterLoadQuery(value: ICallback) {
    this.clearChanges();

    this.stopRotatingAnimation();
    if (value) {
      value.callback();
    }
   }

  isEntityWithGrouping() {
    let isGrouping = false;
    this.toolbarObject.current.Entities.forEach(entity => {
      const column = entity.Columns.find(column => {
        return column.IsGroupBy;
      });

      if (column) {
        isGrouping = true;
        return;
      }
    });

    return isGrouping;
  }

  isQueryValid(): boolean {
    return !this.toolbarObject.readonlyFirstMode && !!(
      this.toolbarObject.current.Query && (
        this.isEntityWithGrouping() ? this.toolbarObject.current.QueryDetail : true
      )
    );
  }

  clearChanges() {
    this.countChanges = 0;
  }

  getMessageTitleQueryTab() {
    return this.countChanges ? `Há ${this.countChanges} mudança(s), clicque para atualizar a query` : 'Atualizar query';
  }

  //#endregion

  //#region Provider and Entities

  onProviderChange() {
    const current = this.toolbarObject.current;

    if (current.Provider) {

      if (current && current.Entities && current.Entities.length  && !this.firstLoad) {
        const description = 'Confirma a troca de provedor? \n Essa ação excluirá as entidades vinculadas no relatório';

        DialogConfirmHelper.showConfirmDialog(this.dialog, description).subscribe(value => {
          if (value) {
            current.Entities = [];
            current.RelatedEntities = [];
            this.loadEntitiesByProvider(current.Provider.Id);
          } else {
            current.Provider.Id = this.pristineProviderId;
          }
        });
      } else {
        this.loadEntitiesByProvider(current.Provider.Id);
        this.firstLoad = false;
      }

    }
  }

  loadEntitiesByProvider(providerId: number) {

    this.pristineProviderId = providerId;

    this.entities = [];

    const obj: Entity = {
      Provider : {
        Id: providerId
      },
      EntityType: EntityTypeEnum.None
    };

    this.subscription.add(
      this.entityService.getByAmount(obj, 1, 1000).subscribe(result => {
        if (result.Data.length === 0) {
          this.alert.warning('Não há entidades cadastradas para este provedor');
        } else {
          result.Data.forEach(entity => {
            this.entities.push({
              EntityId: entity.Id,
              Entity: entity,
              Alias: entity.Description,
              Columns: [],
              Configuration: null,
              Filters: [],
              Id: null,
              IsMain: false,
              Type: FilterTypeEnum.Equal
            });
          });
        }
      })
    );
  }

  //#endregion

  //#region Utils

  setSessionId() {
    this.sessionId = '_' + getRandomId();
  }

  setDefaultFullScreenState() {
    this.fullScreenState = 'default';
  }

  fullScreenStateChange(value: string) {
    const tabgroupElm = this.matGroupRef._elementRef ? this.matGroupRef._elementRef.nativeElement : null,
      matHeader = tabgroupElm ? tabgroupElm.firstChild : null;

    if (matHeader) {
      const style = value === 'default' ? 'flex' : 'none';
      this.renderer.setStyle(matHeader, 'display', style);
    }
  }

  //#endregion

  selectedTabChange(event: MatTabChangeEvent) {
    this.verifyChanges = !event.index;
    if (event.index === 0) {
      this.canShowFilterOptions = true;
      this.canShowColumnOptions = true;
    } else {
      this.canShowFilterOptions = false;
      this.canShowColumnOptions = false;
    }
  }

  getColumnLength(): number {
    const current = this.toolbarObject.current,
     entities = current.Entities != null && current.Entities.length > 0 ? current.Entities : null;
    let length = 0;

    if (entities != null) {
      entities.forEach(value => {
        length += value.Columns.length;
      });
    }

    return length;
  }
}
